export const teamDirectory = {
  contacts: [
    { name: 'Head of Design', role: 'Design Leadership', email: 'head-of-design@company.com', slack: '@head-design' },
    { name: 'Content Strategy Lead', role: 'Content Leadership', email: 'content-lead@company.com', slack: '@content-lead' },
    { name: 'UX Designer', role: 'Design Collaboration', email: 'ux-designer@company.com', slack: '@ux-designer' },
    { name: 'Product Manager', role: 'Product Strategy', email: 'product-manager@company.com', slack: '@product-manager' }
  ],
  mentors: [
    { name: 'Senior Content Designer Mentor', expertise: 'UX Writing & Content Strategy', availability: 'Mon-Fri 2-4 PM' },
    { name: 'Content Operations Mentor', expertise: 'Content Systems & Processes', availability: 'Tue/Thu 10 AM-12 PM' },
    { name: 'Voice & Tone Mentor', expertise: 'Brand Voice & Editorial Guidelines', availability: 'Wed/Fri 3-5 PM' }
  ],
  collaborators: [
    { team: 'Design Team', contact: 'design-team@company.com', purpose: 'Design Integration & Content-Design Collaboration' },
    { team: 'Product Team', contact: 'product-team@company.com', purpose: 'Product Content Strategy & User Journey Writing' },
    { team: 'Marketing Team', contact: 'marketing-team@company.com', purpose: 'Brand Voice Alignment & Marketing Content' },
    { team: 'Engineering Team', contact: 'engineering-team@company.com', purpose: 'Content Implementation & CMS Integration' }
  ],
  channels: {
    primary: '#content-design',
    announcements: '#content-announcements',
    help: '#content-help',
    strategy: '#content-strategy',
    review: '#content-review',
    systems: '#content-systems',
    collaboration: '#design-content-collab'
  }
};
